// extracted by mini-css-extract-plugin
export default {"couponMainContainer":"CuponLabel_couponMainContainer__XQOUx","couponLabelContainer":"CuponLabel_couponLabelContainer__0GUxg","couponLabel":"CuponLabel_couponLabel__5ziT-"};